import { ReactNodeViewRenderer } from "@tiptap/react"

import { BaseAttachmentNode } from "../BaseAttachment/extension"
import { DocumentAttachmentNodeComponent } from "./Component"

export const DocumentAttachmentNode = BaseAttachmentNode.extend({
	addNodeView() {
		return ReactNodeViewRenderer(DocumentAttachmentNodeComponent)
	},
})
